import __request__ from "routing/request";
export function resolveEntities(JSONbody) {
  return __request__("POST", "/system/catalog", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function showEntityIndex() {
  return __request__("GET", "/system/catalog", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getTitles(JSONbody) {
  return __request__("POST", "/system/catalog/entities/titles", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
